import React, { useEffect } from 'react'
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { FiSettings } from 'react-icons/fi';
import { useStateContext } from '../contexts/ContextProvider';
import { Navbar, Notification, Sidebar, ThemeSettings } from '../components';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosClient from '../axios-client';
import Navbar2 from '../components/Navbar2';

const DefaultLayout = () => {
  const getUser = () => {
    axiosClient.get('/user')
      .then((response) => {

        setUser(response.data.user);
      }).catch(error => {
        setToken(null);
        localStorage.removeItem('ACCESS_TOKEN');
        navigate('/login');

      })
  }
  useEffect(() => {
    getUser();
  }, []);
  const { activeMenu, themeSettings, setThemeSettings,
    currentColor, token, setUser, setToken } = useStateContext();

  const navigate = useNavigate();


  if (!token) {
    return <Navigate to="/login" />
  }




  return (
    <div translate='no'>
      
      
     
      
        
        
        {/* start content */}
        
          
          <Navbar2 />
          <Outlet />
          

        

      

    </div>
  )
}

export default DefaultLayout